export const waveFormPropsList = [
    "audioRate",
    "audioContext",
    "audioScriptProcessor",
    "autoCenter",
    "backend",
    "backgroundColor",
    "barGap",
    "barHeight",
    "barMinHeight",
    "barRadius",
    "barWidth",
    "closeAudioContext",
    "cursorColor",
    "cursorWidth",
    "fillParent",
    "forceDecode",
    "height",
    "hideScrollbar",
    "interact",
    "loopSelection",
    "maxCanvasWidth",
    "mediaControls",
    "mediaType",
    "minPxPerSec",
    "normalize",
    "partialRender",
    "pixelRatio",
    "progressColor",
    "removeMediaElementOnDestroy",
    "renderer",
    "responsive",
    "scrollParent",
    "skipLength",
    "splitChannels",
    "waveColor",
    "autoCenterRate",
    "autoCenterImmediately",
    "drawingContextAttributes",
    "duration",
    "ignoreSilenceMode",
    "rtl",
    "splitChannelsOptions",
    "vertical",
    "xhr"
];
const getWaveFormOptionsFromProps = (props) => {
    if (!props)
        return {};
    return waveFormPropsList.reduce((waveFormOptions, optionName) => {
        if (!Object.prototype.hasOwnProperty.call(props, optionName)) {
            return waveFormOptions;
        }
        return Object.assign(Object.assign({}, waveFormOptions), { [optionName]: props[optionName] });
    }, {});
};
export default getWaveFormOptionsFromProps;
